import * as _ from 'lodash';

export const headerData = {
    domain_name: 'domain_name',
    domain_url: 'domain_url',
    domain_folderName: 'domain_folderName',
    sideBlockLeft_hide: 'sideBlockLeft_hide',
    sideBlockLeft_noClick: 'sideBlockLeft_noClick',
    sideBlockRight_hide: 'sideBlockRight_hide',
    subTitle: 'subTitle',
    subTitle_hide: 'subTitle_hide',
    title: 'title',
} as const;

export type THeaderData = (typeof headerData)[keyof typeof headerData];

export interface IHeaderData {
    [headerData.domain_name]?: string | null;
    [headerData.domain_url]?: string | null;
    [headerData.domain_folderName]?: string | null;
    [headerData.sideBlockLeft_hide]: boolean;
    [headerData.sideBlockLeft_noClick]: boolean;
    [headerData.sideBlockRight_hide]: boolean;
    [headerData.subTitle]: string | null;
    [headerData.subTitle_hide]: boolean;
    [headerData.title]: string | null;
}

export class HeaderData 
    implements IHeaderData
{
    [headerData.domain_name]: string | null = null;
    [headerData.domain_url]: string | null = null;
    [headerData.domain_folderName]: string | null = null;
    [headerData.sideBlockLeft_hide]: boolean = false;
    [headerData.sideBlockLeft_noClick]: boolean = false;
    [headerData.sideBlockRight_hide]: boolean = false;
    [headerData.subTitle]: string | null = null;
    [headerData.subTitle_hide]: boolean = true;
    [headerData.title]: string | null = null;

    private constructor(data?: Partial<IHeaderData>) {
        if (!data) return;

        this[headerData.sideBlockLeft_hide] = data[headerData.sideBlockLeft_hide] ?? this[headerData.sideBlockLeft_hide];
        this[headerData.sideBlockLeft_noClick] = data[headerData.sideBlockLeft_noClick] ?? this[headerData.sideBlockLeft_noClick];
        this[headerData.sideBlockRight_hide] = data[headerData.sideBlockRight_hide] ?? this[headerData.sideBlockRight_hide];
        this[headerData.subTitle] = data[headerData.subTitle] ?? this[headerData.subTitle];
        this[headerData.subTitle_hide] = data[headerData.subTitle_hide] ?? this[headerData.subTitle_hide];
        this[headerData.title] = data[headerData.title] ?? this[headerData.title];
        this[headerData.domain_name] = data[headerData.domain_name] ?? this[headerData.domain_name];
        this[headerData.domain_url] = data[headerData.domain_url] ?? this[headerData.domain_url];
        this[headerData.domain_folderName] = data[headerData.domain_folderName] ?? this[headerData.domain_folderName];
    }

    static create(data?: Partial<IHeaderData> | null): IHeaderData | null {
        return !!data ? new HeaderData(data) : null;
    }
}
